module.exports = __webpack_public_path__ + "static/media/delete-red-light.50192b88.svg";